<template>
  <div @click="openfile" class="imageupload upload-select-picture-card">
    <input
        hidden
        type="file"
        accept="image/*"
        ref="imageupload"
        v-on:change="upload($event.target.files)"
    />
    <div  v-if="loading" class="imageupload">
      <v-progress-circular
          :size="50"
          :width="2"
          class="imgupload"
          color="red"
          indeterminate
      ></v-progress-circular>
      <div class="upload-text">
        Uploading....
      </div>
    </div>
    <img alt="bannerup" style="position: relative" v-if="value.length>0" width="100%" :src="imgserc"/>

    <div v-else class="imageupload">
      <img v-if="!loading && done"
           class="imgupload"
           :src="src"
           alt="image"
           width="100%"
           height="200"/>
      <v-icon v-if="!done && !loading">backup</v-icon>
      <div v-if="!done && !loading" class="upload-text">
        {{label}}
      </div>
    </div>

  </div>
</template>

<script>
import { serviceUpload } from '@/services/serviceupload'
function init () {
  return {
    loading: false,
    done: false,
    src: ''
  }
}
export default {
  name: 'ImageBannerUploader',
  props: ['label', 'value', 'loadingupload', 'doneupload'],
  data: function () {
    return init()
  },
  watch: {
    value: function () {
      this.src = ''
      this.done = false
      this.loading = false
    }
  },
  computed: {
    imgserc: {
      get () {
        return this.value
      },
      set (val) {
        this.src = val
      }
    }
  },
  created () {
    this.$parent.$on('clearupload', function () {
      console.log('clear upload child on')
      this.src = ''
    })
  },
  // watch: {
  //   value: function () {
  //     this.src = ''
  //   }
  // },
  mounted () {
  },
  methods: {
    cleardata () {
      this.src = ''
    },
    showPreview: async function (file) {
      var reader = new FileReader()
      var self = this
      if (file) {
        this.loading = true
        serviceUpload.newuploadimage(file)
          .then(response => {
            this.loading = false
            this.done = true
            self.$emit('setimage', response.data)
            window.getApp.$emit('DONE_UPLOAD_BANNER', response.data)
          })
          .catch(error => {
            this.loading = false
            this.done = false
            console.log('err upload')
            console.log(error)
          })
        reader.readAsDataURL(file)
        this.src = await new Promise((resolve) => {
          reader.onload = function () {
            resolve(reader.result)
          }
        })
      }
    },
    openfile () {
      this.$refs.imageupload.click()
    },
    upload: function (files) {
      this.showPreview(files[0])
    }
  }
}
</script>

<style scoped>
.upload-select-picture-card .upload-text {
  margin-top: 8px;
  color: #666;
}
.upload-select-picture-card {
  display: table;
  width: 90%;
  height: 125px;
  margin-right: 8px;
  margin-left: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color .3s ease;
}
.imageupload {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  margin: 8px;
  padding: 8px;
  color: rgba(0,0,0,.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  outline: 0;
}
.upload-select-picture-card > .imageupload {
  display: table-cell;
  width: 100%;
  height: 100%;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}
</style>
